"use client";

import React from "react";
import { Phone } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function FinalCta() {
  const shouldReduceMotion = useReducedMotion();
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 18
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.45,
        ease: [0.21, 0.47, 0.32, 0.98]
      }
    }
  };
  return <section id="finalcta" data-nav="light" className="relative overflow-hidden bg-background py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          amount: 0.2
        }} variants={cardVariants}>
            <Card className="relative overflow-hidden border border-border/80 bg-card p-0 shadow-lg sm:rounded-2xl">
              {/* 3px BMF Blue Datum Line Motif */}
              <div className="h-[3px] w-full bg-primary" aria-hidden="true" />

              <CardContent className="px-6 py-10 sm:px-12 sm:py-14 text-center">
                <div className="mx-auto max-w-2xl space-y-4">
                  <h2 className="font-default text-2xl font-bold tracking-tight text-foreground sm:text-3xl lg:text-4xl">
                    Need scaffolding for your next project?
                  </h2>
                  <p className="font-default text-base leading-relaxed text-muted-foreground sm:text-lg">
                    Whether you&apos;re planning residential work, running a roofing programme or managing a larger commercial project, speak directly with BMF about your scaffolding requirements.
                  </p>
                </div>

                <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-5">
                  <Button size="lg" asChild className="w-full sm:w-auto font-medium px-8 py-6 text-base bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:ring-ring">
                    <Link to="/ContactRequestQuotePage">
                      Request a Quote
                    </Link>
                  </Button>

                  <Button variant="secondary" size="lg" asChild className="w-full sm:w-auto font-medium px-7 py-6 text-base bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 focus-visible:ring-ring">
                    <a href="tel:01344929900" className="inline-flex items-center justify-center gap-2.5">
                      <Phone className="size-4" aria-hidden="true" />
                      <span>Call BMF — 01344 929900</span>
                    </a>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>;
}